module.exports = __webpack_public_path__ + "img/image6.bbfac00d.jpg";